import startsWith from 'lodash/startsWith';
import endsWith from 'lodash/endsWith';

const checkIsExactSearchFilter = (queries: string[]): boolean =>
  Boolean(queries.filter((q) => startsWith(q, '"') && endsWith(q, '"')).length);

export default checkIsExactSearchFilter;
